import type { ReactNode } from 'react';

export type BadgeKind = 'ok' | 'warn' | 'bad' | 'info' | 'mute';

/**
 * Cor com significado, nunca decoração: verde é bom, âmbar pede atenção,
 * vermelho é problema, maré é informativo, cinza é neutro/inativo.
 */
export function StatusBadge({ kind = 'mute', children }: { kind?: BadgeKind; children: ReactNode }) {
  return <span className={`badge badge--${kind}`}>{children}</span>;
}

/**
 * Selo só na exceção.
 *
 * "Ativo" é o estado esperado de quase toda linha: um selo verde repetido
 * vinte vezes não informa nada e ainda gasta o verde que precisa significar
 * dinheiro pago. Ativo vira texto apagado; inativo, que é o que muda a
 * decisão de quem lê, ganha o selo.
 */
export function ActiveBadge({ active }: { active: boolean }) {
  return active ? (
    <span className="quiet">Ativo</span>
  ) : (
    <StatusBadge kind="mute">Inativo</StatusBadge>
  );
}
